import type React from 'react'

import { createVariants } from '../lib'

const cardSidebarClasses = createVariants({
  base: 'w-full px-3 sm:px-5 lg:px-6 py-3 lg:py-6 h-fit bg-white rounded-xl',
  variants: {
    full: {
      false: 'lg:w-72'
    }
  },
  defaultVariants: {
    full: false
  }
})

/**
 *  @group UI Components
 */
export const CardSidebar: React.FC<React.ComponentPropsWithRef<'nav'> & { full?: boolean }> = ({
  full,
  className,
  ...props
}) => <nav className={cardSidebarClasses({ full, className })} {...props} />
